import React from 'react';

import { Button, ButtonTypes } from '@eika/button';
import { ErrorCard } from '@eika/card';
import { RichIcon, RichIconTypes } from '@eika/rich-icon';

import useText from '@hooks/use-text';
import DEFAULT_APP_NAMESPACE from '@utils/modal';
import EikaModal from '@utils/modal/EikaModal';

interface ReopenCardErrorCardModalProps {
    show: boolean;
    onClose: () => void;
}

const ReopenCardErrorCard = () => {
    const { reopenCardErrorTitle, reopenCardErrorDescription } = useText();
    return (
        <ErrorCard
            isModal
            title={reopenCardErrorTitle}
            description={reopenCardErrorDescription}
            icon={<RichIcon type={RichIconTypes.HAAND_HEIHEI} />}
        />
    );
};

const ReopenCardErrorCardModal = ({ show, onClose }: ReopenCardErrorCardModalProps) => {
    const { formBack } = useText();
    return (
        <EikaModal id="reopen-card-unavailable" appNamespace={DEFAULT_APP_NAMESPACE} setOpen={onClose} open={show}>
            <ReopenCardErrorCard />
            <div className="error-container-buttons">
                <Button className="modal-actions" buttonType={ButtonTypes.STANDARD_POSITIVE} onClick={onClose}>
                    {formBack}
                </Button>
            </div>
        </EikaModal>
    );
};

export default ReopenCardErrorCardModal;
